// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
/**
 * Lazy loader for portfolio view renderer
 */ export const portfolioRenderLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-portfolio-render" */ "./portfolioViewRenderer")).then((bundle)=>{
        return bundle.portfolioViewRenderer;
    });
/**
 * Lazy loader for portfolio view instantiator
 */ export const portfolioInstantiateLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-portfolio-instantiate" */ "./PortfolioViewInstantiator")).then((bundle)=>{
        return bundle;
    });
export const LazyPortfolioView = /*#__PURE__*/ lazy(()=>portfolioRenderLoader().then((mod)=>{
        return {
            default: ()=>mod.render({
                    modalLayerHostId: "modalLayerHostId"
                })
        };
    }));
